import { CheckCircleOutline } from "@mui/icons-material";

export default function Alert() {
  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          success: <CheckCircleOutline />,
        },
      },
      styleOverrides: {
        standardSuccess: {
          color: "#4CAF50",
        },
        standardWarning: {
          color: "#6D4E00",
        }
      },
    }
  };
}
